import { useMutation } from 'react-query';
import { EmailPreferences } from '../../models/EmailPreferences';
import { saveEmailPreferences } from '../../services/user.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => useMutation<EmailPreferences, void, EmailPreferences, void>((emailPreferences) => saveEmailPreferences(emailPreferences));
